import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {CustomQueryEncoderHelper} from './custom-query-encoder-helper';
import {DeletePendingGroupUserRequest} from '../models/group-user';
import {Simple200Response} from '../models/general';
import {Observable} from 'rxjs/index';
import {environment} from '../../../environments/environment';

@Injectable()
export class GroupUserService {

  constructor(private httpClient: HttpClient) {
  }

  deletePendingGroupUser({organizationToken, email, groupId}: DeletePendingGroupUserRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.afbV2Host}org-users/self/groups/${groupId}/invitations`;
    // Using custom query param encoder to support alias(+) emails
    const params = new HttpParams({
      encoder: new CustomQueryEncoderHelper(),
      fromObject: {email}
    });

    return this.httpClient
      .delete<Simple200Response>(url, {headers, params});
  }
}
